import { getQueryString, setDocumentTitle } from '@/utils'
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import { routes } from './router.config'

import { useAuthStore } from '@/store/auth'
import { whiteListPage } from '@/router/whiteList'
import { myAppServiceMenuAPI } from '@/api'
import { Toast } from 'vant'
import getNativeInstance from '@/utils/JSBridge'

const showAppDefaultStatusbarPathList: string[] = [] // 需要显示app状态栏的页面路径
const whiteList = ['/ys', '/oauth', '/s-ys', '/s-fw'] //免登白名单
const router = createRouter({
	history: createWebHistory(import.meta.env.VITE_PUBLIC_PATH),
	routes,
	strict: true,
	scrollBehavior: () => ({ left: 0, top: 0 })
})

router.beforeEach(async (to, from, next) => {
	document.title = to.meta.title || '掌上新大'
	console.log('20250623')
	if (window.UniAppJSBridge) {
		// v1.0，通知app设置顶部状态栏
		getNativeInstance().customInvoke({
			action: 'setAppStatusBar',
			data: {
				visible: showAppDefaultStatusbarPathList.includes(to.path)
			}
		})
	}
	// 白名单直接跳转
	if (whiteList.includes(to.path)) {
		next()
		return
	}
	const authStore = useAuthStore()
	// 2.0 cas登录时，获取的ticket
	const ticket = getQueryString('ticket') || to.query.ticket
	console.log('H5获取ticket====', ticket)
	if (ticket) {
		// 2.0 如果有ticket，则发给app，app使用ticket进行登陆过
		// alert(ticket)
		if (window.UniAppJSBridge) {
			loginToWx(ticket)
		} else {
			document.addEventListener('UniAppJSBridgeReady', function () {
				loginToWx(ticket)
			})
		}
		console.log('H5获取wx sdk====', window.wx)
		if (wx) {
			console.log('触发小程序回退，发送postmessage')
			wx.miniProgram.navigateBack()
		}
	}
	setDocumentTitle(to.meta.title as string)
	if (whiteListPage.includes(to.path)) {
		next()
		return
	}
	// 1.0、2.0 使用ticket进行cas登录，因为app部分页面使用的H5，所以H5也要登录一下
	if (ticket && (!authStore.userInfo || !authStore.userInfo.F_UserId)) {
		try {
			await authStore.getUserInfo(ticket)
			// 直接终止掉不进去
			return
		} catch (e) {
			console.log(e)
			return
		}
	}
	// 重新打开APP，第一次进来随便调用个接口判断是不是登录失效
	// const isFirstLogin = !sessionStorage.getItem('isFirstLogin')
	// if (isFirstLogin) {
	// 	let _loading: any = null
	// 	try {
	// 		_loading = Toast.loading({ duration: 0 })
	// 		await myAppServiceMenuAPI({
	// 			userName: authStore.userInfo.F_UserId,
	// 			tenantId: '1a1cb2b893d34fcea1d041681f6c9586'
	// 		})
	// 		sessionStorage.setItem('isFirstLogin', '1')
	// 		next()
	// 	} catch (e) {
	// 		console.log(e)
	// 	} finally {
	// 		if (_loading) {
	// 			_loading.clear()
	// 		}
	// 	}
	// } else {
	// 	next()
	// }
	next()
})

router.afterEach((to, from, next) => {})

function loginToWx(ticket) {
	console.log('H5发起登录请求====', ticket)
	getNativeInstance().customInvoke({
		action: 'loginByCas',
		data: {
			ticket: ticket
		}
	})
}
export default router
